import type { PharmacyWorkingHoursStatusSizeModel } from '@develop/ia-api-library'
import type { ChannelInput, NoQ, Pharmacy } from '@/models/generated/iade'

export type MarkerSizes = 'xs' | 'sm' | 'md' | 'lg' | 'xl'

export type WorkingStatusSize = 'small' | 'medium' | 'large'

export type ApoFinderFiltersModalModel = Pick<ApofinderFiltersModel, 'services' | 'magazines' | 'isOpen' | 'hasDelivery' | 'withOnlinePayment' | 'orderPossible'>

export type ExpandedPharmacyWorkingHoursStatusModel = Record<
  WorkingStatusSize,
  PharmacyWorkingHoursStatusSizeModel & { fullLabel: string }
>

export type ApofinderFiltersModel = {
  services: string[]
  magazines: string[]
  noqServices: string[]
  channels: ChannelInput[]
  isOpen: boolean
  hasDelivery: boolean
  withOnlinePayment: boolean
  orderPossible: boolean
  selectedGeolocation?: { lat?: number; lon?: number }
  offset?: number
  limit?: number
  plz?: string
  pcase?: string[]
  pzn?: string[]
  test: boolean
  isEmergency: boolean
  geolocation: boolean
  // System service filters for appointment booking
  activeServiceTypeIds?: number[]
  activeServiceGroupIds?: number[]
  // Medical aid filter
  allowsMedicalAid?: boolean
  onlyVersorgerPharmacies?: boolean
  // Laboratory tests filter
  hasLaboratoryTests?: boolean
}

export type NoqFiltersModel = {
  selectedGeolocation?: { lat?: number; lon?: number }
  noqServices?: string[]
  limit?: number
  offset?: number
  geolocation: boolean
}

export type PharmacyExtended = Pharmacy & {
  onlineOrderPossible: boolean
  noQ?: NoQ
}

export type PharmacyUrlModel = {
  id: string | number
  city: string
  postcode: string
  name: string
}

export type DeactivatedPharmacyCookie = {
  id: number
  postcode?: number
}

export const DefaultChannelId = 1
